import React, { Component } from "react";
import ChoicePopup from "../2/Controls/ChoicePopup";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import ExportButton from "../2/Controls/ExportButton";
import Button from "../2/Controls/Button";
import * as actionTypes from "../../actionTypes";
import { exportFile } from "../../actions/DataExporter";


class InventoryInTransit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      showNewModal: false,
      inventoryTransactionTypes: [],
      selectedRow: null,
      isFilterActive: false,
      listPageSettings: {
        Title: "Inventory In Transit",
        Search: {
          showSearch: false,
        },
        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
        ],
       Columns: [
          {
            Name: "#",
            Type: "multiple",
            Columns: [
              { Column: "TransactionNo" },
              {
                Column: "CancellationReasonDisplay",
                Type: "badge",
                CSS: "red",
              },
            ],
          },
          {
            Name: "Transaction Type",
            Type: "field",
            Columns: [
              { Column: "TransactionType.TransactionType", Type: "text" },
              { Column: "ParentTransactionNo", Type: "badge", CSS: "green" },
            ],
          },
          {
            Name: "Date",
            Type: "field",
            Columns: [{ Column: "TransactionDate", Type: "date" }],
          },
          {
            Name: "Store",
            Type: "field",
            Columns: [{ Column: "Store.StoreName" }],
          },
          {
            Name: "Store",
            Type: "multiple",
            Columns: [
              { Column: "Vendor.VendorFirstName", Type: "text" },
              { Column: "Vendor.VendorLastName", Type: "text" },
              { Column: "Vendor.VendorCode", Type: "text" },
              { Column: "FromStore", Type: "text" },
              { Column: "ToStore", Type: "text" },
            ],
          },
          {
            Name: "Ref No",
            Type: "field",
            Columns: [{ Column: "RefNo", Type: "text" }],
          },
          {
            Name: "Notes",
            Type: "field",
            Columns: [{ Column: "Notes", Type: "text" }],
          },
          {
            Name: "Qty",
            Type: "field",
            Columns: [{ Column: "BillQty", Type: "number" }],
          },
          {
            Name: "Total Tax",
            Type: "field",
            Columns: [{ Column: "BillTaxAmount", Type: "number" }],
          },
          {
            Name: "Discount",
            Type: "field",
            Columns: [{ Column: "BillDiscount", Type: "number" }],
          },
          {
            Name: "Additional Discount",
            Type: "field",
            Columns: [{ Column: "BillAdditionalDiscount", Type: "number" }],
          },
          {
            Name: "Additional Charges",
            Type: "field",
            Columns: [{ Column: "BillAdditionalCharges", Type: "number" }],
          },
          {
            Name: "Round Off",
            Type: "field",
            Columns: [{ Column: "BillRoundOff", Type: "number" }],
          },
          {
            Name: "Amount",
            Type: "field",
            Columns: [{ Column: "BillAmount", Type: "number" }],
          },
          {
            Name: "Status",
            Type: "field",
            Columns: [{ Column: "Status", Type: "text" }],
          },
          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "TransactionNo", CSS: "bold" },
              { Column: "TransactionType.TransactionType" },
              { Column: "TransactionDate", Type: "date" },
              { Column: "Store.StoreName" },
              { Column: "BillQty", Type: "text", Label: "Qty" },
              { Column: "BillAmount", Type: "text", Label: "Amount" },
              { Column: "Status", Type: "badge" },
            ],
          },
        ],
        RowButtons: [
        ]
      }
    };
  }

  
  
  renderNewInventoryPopup() {
    return (
      <React.Fragment>
        {this.state.inventoryTransactionTypes.map((e) => (
          <Button
            key={e.key}
            text={"New " + e.TransactionType}
            type="secondary"
            icon="add"
          onClick={() => {
                        this.props.history.push({
                          pathname: "/home/inventory/inventory/",
                          state: { transactionType: e, type: actionTypes.INVENTORY_NEW },
                        });
                      }}
          />
        ))}
      </React.Fragment>
    );
  }


  showTransactionType(transactionType) {
    let showModule = false;
    if (
      this.props.user.user.Role === "Power User" ||
      this.props.user.user.Role === "Store Owner" ||
      this.props.user.user.Role === "Store Manager" ||
      this.props.user.user.Role === "Store Cashier"
    ) {
      showModule = true;
    } else {
      if (
        this.props.user.acl.filter(
          (e) => e.id === transactionType.TransactionType && e.perms.read
        ).length > 0
      ) {
        showModule = true;
      }
    }
    if (this.props.registration.registration.PincodeIntegration) {
      if (
        this.props.registration.registration.hasOwnProperty(
          "PinocdeOrderTransactionTypeID"
        ) &&
        this.props.registration.registration.PinocdeOrderTransactionTypeID ===
        transactionType.key
      ) {
        showModule = false;
      }
    }
    return showModule;
  }

  componentDidMount() {
    let inventoryTransactionTypes = [];


    this.props.config.TransactionTypes.filter(
      (e) => e.Module === "inventory" && !e.IsDeleted
    ).map((e) => {
      if (this.showTransactionType(e)) {
        inventoryTransactionTypes.push(e);
      }
    });

  
    
    this.setState(
      {
        
        inventoryTransactionTypes: inventoryTransactionTypes,
      },
      () => {
        this.loadData();
      }
    );
  }



  loadData = async () => {
    this.setState({ loading: true });

    try {
      const { page, pageSize } = this.state;
      const from = (page - 1) * pageSize;

      const res = await this.props.getInventoryList(
        from,
        pageSize,
        null,
         this.props.user.store.key,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "In Transit",
        ""
      );

      let list = [];
      let totalCount = 0;

      if (res && res.hasOwnProperty("inventory") && res.inventory.length > 0) {
        list = res.inventory;
      }

      if (res && res.hasOwnProperty("totalCount")) {
        totalCount = res.totalCount;
      }

      this.setState({
        list: list,
        totalCount: totalCount,
        loading: false,
        selectAll: false
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  


  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 }, this.loadData);
    }
  };

  onPreviousClick = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 }, this.loadData);
    }
  };

  onFirstClick = () => {
    this.setState({ page: 1 }, this.loadData);
  };

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages }, this.loadData);
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({ pageSize: Number(size), page: 1 }, this.loadData);
  };

 

 

 
  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new") {
      this.setState({ showNewModal: true });
    }
    
  };



  onPageChange = (page, pageSize) => {
    this.setState({ page, pageSize }, () => {
      this.loadData();
    });
  };

  render() {
    

  

  
    
    return (
      <>
        <ListingPage
          {...this.props}
          listPageSettings={this.state.listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          checkboxSelected={this.checkboxSelected}
          selectAll={this.state.selectAll}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onPageChange={this.onPageChange}
           onRowClick={(row) => {
       this.props.history.push({
  pathname: "/home/inventory/viewinventory/" + row.key,
  state: { type: "intransit" }
});
      }}


        />

          {this.state.showNewModal && (
          <ChoicePopup
            header={"New Transaction"}
            height={"200px"}
            stripNew
            onClose={() => this.setState({ showNewModal: false })}
          >
            {this.renderNewInventoryPopup()}
          </ChoicePopup>
        )}
      </>
    );
  }
}

export default InventoryInTransit;